import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Constants from '../Redux/action_types/EPAConstants.js';
import FormCheckmark from 'grommet/components/icons/base/FormCheckmark';
import Alert from 'grommet/components/icons/base/Alert';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import CheckBox from 'grommet/components/CheckBox';
import ReactTooltip from 'react-tooltip';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
let isCurrentTabChecked;

class DisplayTabs extends Component {
       constructor() {
              super();
       }

       onTabChange = ( correspondingTabName) => {
              this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === "yes")["@isCurrentTab"] = "no";
              this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === correspondingTabName)["@isCurrentTab"] = "yes"
              if (this.props.currentTab) {
                     this.props.changeCurrentTab(false);
              } else {
                     this.props.changeCurrentTab(true);
              }
              this.setState({});
       }

       render() {
              let TabToolTip= '';
              let currentTabObject = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_);
              if (currentTabObject["@isSelected"] === Constants.yES_) {
                     isCurrentTabChecked = true;
              } else {
                     isCurrentTabChecked = false;
              }
              let tabsList = this.props.workload.UserInputs.Environments.Environment.map((solution, id) => {
                     let tabBackgroundColor = Constants.WHITE_COLOR;
                     let isChecked = false;
                     let needToCalculate = false;
                     let checkBoxDisplay = Constants.NONE_;
                     let fontColors = Constants.BLACK_COLOR;
                     if (solution["@isCurrentTab"] === Constants.yES_) {
                            tabBackgroundColor = Constants.TAB_BACKGROUND;
                            fontColors = Constants.WHITE_COLOR;
                     }
                     if (solution["@isSelected"] === Constants.yES_) {
                            checkBoxDisplay = Constants.BLOCK_;
                            if (solution.NonGPUValue.isCalculated === Constants.tRUE_ || solution.GPUValue.isCalculated === Constants.tRUE_ || solution.StorageValue.isCalculated === Constants.tRUE_) {
                                   isChecked = true;
                            }
                            else {
                                   needToCalculate = true;
                            }
                     }
                     return (<Box direction="row">
                            <ReactTooltip place="right" multiline={true} id={solution['@SolutionType']} />
                     <Box style={{width: '30px', padding:'10px 5px', display : checkBoxDisplay, background : tabBackgroundColor}}>
                            {isChecked ? <FormCheckmark style={{stroke : 'rgb(1, 169, 130)'}} /> : ''}
                            {needToCalculate ? <Alert style={{stroke : '#ff8d6d'}} /> : ''}
                     </Box>
                     <Heading tag="h4" strong={true} style={{marginRight: '6px', marginBottom : '0px', padding : '10px', background : tabBackgroundColor, color : fontColors}} onClick={() => this.onTabChange(solution["@SolutionType"])}>{solution["@SolutionType"]}
                     <CircleInformation data-tip={Constants.EzemeralServicesToolTips[solution["@SolutionType"]]} data-for={solution['@SolutionType']} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Heading>
              </Box>)
              });
              return(
                     <Box>
                            <Box direction="row" style={{ marginBottom : '10px', borderBottom : '2px solid #01a982' }}>
                                   {tabsList}
                            </Box>
                     </Box>
              );              
       }
}

const mapStateToProps = (state) => {
       return ({
              currentTab: state.sizerWorkload.currentTab,
              workload: state.sizerWorkload.workload,
       })
}

const mapDispatchToProps = (dispatch) => {
       return ({
              changeCurrentTab : (value) => {dispatch({ type : 'UPDATE_SCREEN', payload : value })}
       })
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplayTabs);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/DisplayTabs.js